import React, { useEffect, createElement } from 'react';
import { LandingPage } from './components/LandingPage';
type PixelFunction = ((...args: unknown[]) => void) & {
  queue: unknown[][];
  loaded?: boolean;
  version?: string;
};
type PixelWindow = Window & typeof globalThis & {
  fbq?: PixelFunction;
  _fbq?: PixelFunction;
};
function useMetaPixel() {
  useEffect(() => {
    const pixelWindow = window as PixelWindow;
    if (pixelWindow.fbq) return;
    const fbq = ((...args: unknown[]) => {
      fbq.queue.push(args);
    }) as PixelFunction;
    fbq.queue = [];
    fbq.loaded = true;
    fbq.version = '2.0';
    pixelWindow.fbq = fbq;
    pixelWindow._fbq = fbq;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    document.head.appendChild(script);
    fbq('init', '1474957487774441');
    fbq('track', 'PageView');
  }, []);
}
export function App() {
  useMetaPixel();
  return <LandingPage data-id="element-0" data-mp="23v2sl1d6kx4c" />;
}